import { Box, Divider, Stack } from "@mui/material";
import { type FC, useMemo } from "react";
import { useNotificationsGroupedQuery } from "web_myplann/Api/Notifications/useNotificationsGroupedQuery";
import { NotificationListItem } from "web_myplann/Dashboard/Components/NotificationListItem";
import { dedupeById } from "web_myplann/Dashboard/Utils/dedupeById";
import useIntersectionObserver from "web_myplann/Shared/Hooks/useIntersectionObserver";

export const AllNotificationsTab: FC = () => {
	const {
		data: allPages,
		fetchNextPage: fetchNextAll,
		hasNextPage: hasNextAll,
		isFetchingNextPage: isFetchingNextAll,
	} = useNotificationsGroupedQuery(false);

	const allNotifications = useMemo(
		() => dedupeById(allPages?.pages?.flatMap((p) => p?.data ?? []) ?? []),
		[allPages?.pages],
	);

	const lastAllRef = useIntersectionObserver(
		hasNextAll && !isFetchingNextAll ? () => fetchNextAll() : undefined,
		allNotifications.length,
		undefined,
		!!hasNextAll && !isFetchingNextAll,
	);

	return (
		<Box pt={1.6}>
			<Stack pt={1}>
				{allNotifications.map((notification) => (
					<Stack key={notification.id}>
						<NotificationListItem {...notification} />
						<Box py={1.6}>
							<Divider />
						</Box>
					</Stack>
				))}
				<Box ref={lastAllRef} sx={{ height: 1 }} />
			</Stack>
		</Box>
	);
};
